import {WizardBaseStep} from "../../../models/wizard/wizard-base.step";
import {IFlightSearchRoutes} from "../../navigation/routes/flight-search/flight-search.routes.interface";
import {
    IFlightSearchControllerViewModel
} from "../flight-search-controller/flight-search-controller-view-model.interface";
import {IPsoMarket} from "../../stations/pso-market.interface";
import {PsoUserOptionsEnum} from "../flight-search-controller/pso.enums";
import {DialogCloseButtonBehavior} from "../../dialog/dialog-enums";
import {
    PsoUserOptionWithSeasonDialogComponent
} from "../../../components/territorial-continuity-regime/pso-user-option-with-season-dialog.component";
import {YesNoDialogPrimaryButton, YesNoDialogResult} from "../../dialog-factory/yes-no-dialog.enums";
import {IRoute} from "../../navigation/models/route.interface";

export abstract class FlightSearchStepBase extends WizardBaseStep {
    protected get routes(): IFlightSearchRoutes {
        return this.services.navigator.routes.flightSearch;
    }

    protected async _showPsoConfirmationDialog(searchController: IFlightSearchControllerViewModel, psoMarket: IPsoMarket, nextRoute: IRoute): Promise<void> {

        const activeSeasons = psoMarket.getActiveSeasons(this.services.time.currentDate);
        if(activeSeasons.length > 0) {
            await this.services.dialog.showSheetModalDialog<PsoUserOptionsEnum>({
                closeButtonBehavior: DialogCloseButtonBehavior.Reject,
                render: dialogHandler => (<PsoUserOptionWithSeasonDialogComponent dialogHandler={dialogHandler}  searchController={searchController} psoSeasons={activeSeasons}/>),
        })
        } else {

            const dialogResult = await this.services.dialogFactory.showYesNoDialog({
                title: psoMarket.translations.residentAndEquivalent,
                message: psoMarket.translations.areYouAResident,
                primaryButton: YesNoDialogPrimaryButton.PrimaryButtonYes
            });

            if(dialogResult === YesNoDialogResult.Yes) {
                searchController.psoUserOption = PsoUserOptionsEnum.Resident;

            } else {
                searchController.psoUserOption = PsoUserOptionsEnum.None;
            }
        }

        this._activateStepByRoute(nextRoute);

    }
}
